import { cn } from '@workspace/utils';

export const CONSENT_RECONTACT_DPO_EMAIL = 'dpo@april-moto.com';

interface ConsentRecontactLegalProps {
  className?: string;
}

/**
 * Mentions légales du consentement au rappel téléphonique (ADM Value Assurance).
 * Réutilisé dans le bloc consentement de l'étape coordonnées et dans la fenêtre "être rappelé".
 */
export function ConsentRecontactLegal({ className }: ConsentRecontactLegalProps) {
  return (
    <div className={cn('space-y-2 text-left', className)}>
      <p>
        Pour vous conseiller au mieux dans le cadre de votre démarche vous acceptez d&apos;être recontacté par un conseiller
        mandaté d&apos;APRIL&nbsp;Moto à savoir ADM&nbsp;Value Assurance (n°&nbsp;ORIAS&nbsp;10055724) afin de vous proposer un
        contrat d&apos;assurance 2-roues.
      </p>
      <p>Votre consentement est valable 30 jours à partir de ce jour.</p>
      <p>
        Vous pouvez retirer votre consentement à tout moment, y compris pendant cette période. Pour cela, il vous suffit de
        nous adresser un mail à{' '}
        <a
          className="text-primary font-medium hover:text-primary-600 hover:underline"
          href={`mailto:${CONSENT_RECONTACT_DPO_EMAIL}`}
        >
          {CONSENT_RECONTACT_DPO_EMAIL}
        </a>{' '}
        ou nous le dire oralement lors d&apos;un appel. Le retrait s&apos;effectue selon des modalités qui ne sont pas plus
        complexes que celles de votre consentement.
      </p>
      <p>
        Sur simple demande de votre part par mail ou par courrier, nous vous fournirons gratuitement, sur un support durable,
        la preuve de votre consentement.
      </p>
      <p>
        En l&apos;absence d&apos;un contrat en cours d&apos;exécution, toute sollicitation téléphonique effectuée à des fins
        commerciales, suppose votre consentement préalable.
      </p>
    </div>
  );
}
